<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed } from 'vue';
import logo from '@/assets/img/logo.png';

const { layoutConfig } = useLayout();

const logoUrl = computed(() => {
    return logo;
});
</script>

<template>
    <div class="layout-footer">

    </div>
</template>
<style lang="scss" scoped></style>
